module.exports = __webpack_public_path__ + "img/weak.be5030ca.webp";